module.exports = __webpack_public_path__ + "static/media/4.5_stars.e66b82ec.svg";